import { useState, useEffect } from 'react';
import api from '../../../../data/api';
import tagApi from '@/api/tagApi';
import axios from 'axios';

export const useVideoData = ({
	userInfo,
	startIndex,
	itemsPerPage,
	userData,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	selectedProducts,
	sortby
}) => {
	const [responseData, setResponseData] = useState([]);
	const [totvideos, setTotVideos] = useState('');
	const [tags, setTags] = useState([]);
	const [instructors, setInstructors] = useState([]);
	const [products, setProducts] = useState([
		{
			name: '',
			id: '',
			subname: ''
		}
	]);

	// Fetch tags
	useEffect(() => {
		tagApi.getActiveTags()
			.then(filteredTags => { setTags(filteredTags) })
			.catch(err => console.error('Failed to fetch tags:', err));
	}, []);

	// Fetch instructors
	useEffect(() => {
		axios
			.get(`${import.meta.env.VITE_APP_API_URL}/video/instructors`)
			.then(response => {
				setInstructors(response?.data);
			})
			.catch(err => console.error('Failed to fetch instructors:', err));
	}, []);

	// Fetch video data based on filters
	useEffect(() => {
		fetchData(selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts);
	}, [
		startIndex,
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby,
		userData.token
	]);

	// Function to fetch data from API
	const fetchData = async (selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts) => {
		try {
			const userId = userInfo && userInfo.userId ? userInfo.userId : '';
			const endIndex = startIndex + itemsPerPage - 1;
			const selectedTagsIds = selectedTags?.map(tag => tag).join(',');
			const durations = selectedDurations?.map(duration => duration).join(',');
			const levels = selectedLevels?.map(level => level).join(',');
			// const instructorsParam = selectedInstructors?.map(instructor => instructor).join(',');
			// const productsParam = selectedProducts?.map(product => product).join(',');

			const response = await api.getSingleFilteredVideos({
				startIndex,
				endIndex,
				selectedTags: selectedTagsIds,
				selectedDurations: durations,
				selectedLevels: levels,
				sortby: sortby || 'latest',
				selectedInstructors: selectedInstructors,
				selectedProducts,
				userId
			});

			if (response.data.libraryVideosData && response.data.libraryVideosData[0]) {
				setTotVideos(Math.ceil(response.data.libraryVideosData[0].totalRecords / itemsPerPage));
				setResponseData(response.data.libraryVideosData);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	return {
		responseData,
		setResponseData,
		totvideos,
		fetchData,
		tags,
		instructors,
		products,
		setProducts
	};
};
